import React, { useLayoutEffect, useRef } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

const Bopomofo = ({ className, zhuyin = '', word = '' }) => {
  const rubyRef = useRef(null);
  useLayoutEffect(() => {
    const parentNode = rubyRef.current.parentNode;
    const isBopomofo = Array.from(parentNode.classList).some(className => className.includes('bopomofo'));
    if (isBopomofo && !window.electron) {
      const fontSize = window.getComputedStyle(rubyRef.current).fontSize;
      // rubyRef.current.style.display = 'inline-block'
      rubyRef.current.style.left = `min(-26px, -${Number(fontSize.replace('px', ''))/1.2}px)`;
    }
  }, [])
  return (
  <div className={classnames(styles.v, className)}>
    <ruby ref={rubyRef}>{word}<rt>{zhuyin}</rt></ruby>
  </div>
)};

export default Bopomofo;
